<template>
<div>
 <loading-spinner v-if="!sticker" />  
  <div v-if="sticker">
    <app-header :title="sticker.name" :subtitle="'Sticker #'+sticker.id">
      <b-button v-router-link="{name:'sticker-editor',query:{id:sticker.id}}" variant="primary">
        <i class="fa fa-pencil-square-o" style="font-size:20px" /> Edit Sticker
      </b-button>
    </app-header>
    
    <b-container>
      <b-tabs>
        <b-tab title="Profile" class="tab-pane fade show active mt-3">
          <b-card-group columns>
            <b-card no-body>
              <b-card-header>
                Image
              </b-card-header>
              <b-table-simple>
                <b-tr>
                  <b-td class="text-center">
                    <img :src="'https://cdn.gokaizen.com/' + sticker.src" alt="" style="max-width:100%;">
                  </b-td>
                </b-tr>
              </b-table-simple>
            </b-card>
            <b-card no-body>
              <b-card-header>
                Description
              </b-card-header>
              <b-table-simple>
                <b-tr>
                  <b-td>Category</b-td>
                  <b-td v-router-link="{name:'mediacategory-detail', params:{id:sticker.category_id}}" class="text-right">
                    {{ sticker.category_name }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <td>Created</td>
                  <b-td class="text-right">
                    {{ sticker.created | moment("YYYY-MM-DD") }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td>Updated</b-td>
                  <b-td class="text-right">
                    {{ sticker.updated | moment("YYYY-MM-DD") }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td>Tags</b-td>
                  <b-td class="text-right">
                    {{ sticker.tags || 'No tags specified' }}
                  </b-td>
                </b-tr>
              </b-table-simple>
            </b-card>
          </b-card-group>
        </b-tab>
      </b-tabs>
    </b-container>
  </div>
</div>
</template>

<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
  components: {
    AppHeader,
    LoadingSpinner
  },

  data() {
    return {
      query: '',
      sticker: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      const stickerId = this.$route.params.id;

      $api.get(`/v1/internal/stickers/${stickerId}`).then((sticker) => {
        this.sticker = sticker;
      });
    },
  },
};
</script>
